import React from 'react';

const Resume = () => {
    return (
       <div>
            <iframe src="./Resume/Tanjir-Ahmed- Resume.pdf" width="100%"/>
       </div>

    )
}

export default Resume;